// extracted by mini-css-extract-plugin
export default {"name":"useTagsFilter_name__+ZzRB"};